// extracted by mini-css-extract-plugin
export default {"infoContainer":"CustomerInfo_infoContainer__qIcCF","summarySection":"CustomerInfo_summarySection__7WHNc"};